import { useForm } from "react-hook-form";

import CustomInput from "../../../components/UI/PageInput/CustomInput";
import CenteredHeading from "../../../components/UI/headingsUI/CenteredHeading";
import GrayButton from "../../../components/UI/buttonUI/GrayButton";
import AddVehicleSuccess from "../dialog/AddVehicleSuccess";
import PrimaryButton from "../../../components/UI/buttonUI/PrimaryButton";
import { CirclePlus } from "lucide-react";
import {
  noSpaceOnlyValidation,
  phoneValidation,
} from "../../../validations/formValidations";

const AddVehicleForm = ({ loading, sendData, successResponse }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = (data) => {
    sendData(data, reset);
  };

  return (
    <div className="form-container">
      <CenteredHeading title="Add Vehicle" />
      <form
        className="cy-receive-form"
        onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}
      >
        <div className="flex flex-wrap 2xs:max-md:pt-2">
          <div className="inputLeftCol">
            <CustomInput
              type="text"
              name="vehicle_number"
              labelText="Vehicle Number *"
              placeholder="Enter"
              register={{
                ...register("vehicle_number", {
                  ...noSpaceOnlyValidation,
                  required: "Please enter vehicle number",
                }),
              }}
              error={errors.vehicle_number}
            />
          </div>
          <div className="inputRightCol">
            <CustomInput
              type="text"
              name="driver_name"
              labelText="Driver Name *"
              placeholder="Enter"
              register={{
                ...register("driver_name", {
                  ...noSpaceOnlyValidation,
                  required: "Please enter a name",
                }),
              }}
              error={errors.driver_name}
            />
          </div>
        </div>
        <div className="flex flex-wrap 2xs:max-md:pt-2">
          <div className="inputLeftCol">
            <CustomInput
              type="tel"
              name="driver_mobile"
              labelText="Driver Phone *"
              placeholder="Enter"
              register={{
                ...register("driver_mobile", {
                  ...phoneValidation,
                  required: "Please enter a phone",
                }),
              }}
              error={errors.driver_mobile}
            />
          </div>
          <div className="inputRightCol">
            <CustomInput
              type="number"
              name="vehicle_reading"
              labelText="Vehicle Reading"
              placeholder="Enter"
              register={{
                ...register("vehicle_reading", {
                  validate: (value) => {
                    if (value.toString().length > 8) {
                      return "Invalid vehicle reading";
                    }
                    return true;
                  },
                }),
              }}
              error={errors.vehicle_reading}
            />
          </div>
        </div>
        <CustomInput
          type="text"
          name="vehicle_model"
          labelText="Vehicle Model"
          placeholder="Enter"
          register={{
            ...register("vehicle_model"),
          }}
          error={errors.vehicle_model}
        />
        <div className="submitWrap">
          <p className="pr-2">
            <PrimaryButton
              btnText={!loading ? "Add Vehicle" : "Adding..."}
              loading={loading}
              Icon={CirclePlus}
              size={20}
            />
          </p>
          <p className="pl-2">
            <GrayButton btnText="Clear" width="w-40" onClick={() => reset()} />
          </p>
        </div>
      </form>
      {successResponse && <AddVehicleSuccess viewDetails={successResponse} />}
    </div>
  );
};
export default AddVehicleForm;
